import useStepperState from './useStepperState';

const useStepGateState = id => {
  if (id == null) {
    throw new Error('Id in `useStepGateState` must not be null');
  }

  const stepperState = useStepperState();

  return {
    ...stepperState.gates.get(id),
    isCurrentGate:
      [...stepperState.gates.keys()][stepperState.currentGate] === id,
  };
};

export default useStepGateState;
